import React from 'react';
import { useNavigate } from 'react-router-dom';
import SentimentDissatisfiedIcon from '@mui/icons-material/SentimentDissatisfied'; // Sad face icon for 404
import { routes } from '../../config/utility';
import ThemeButton from '../../components/atoms/ThemeButton';

const NotFoundPage = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate(routes.dashboard);
  };

  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen bg-body-auth overflow-hidden">
      {/* Background blobs */}
      <div className="absolute -top-24 -left-24 w-96 h-96 bg-gradient-to-br from-primary to-secondary opacity-30 rounded-full blur-3xl z-0 animate-pulse" />
      <div className="absolute bottom-0 right-0 w-80 h-80 bg-gradient-to-tr from-accent to-accentSecondary opacity-20 rounded-full blur-2xl z-0 animate-pulse delay-200" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[300px] bg-gradient-to-r from-primary/10 to-secondary/10 opacity-40 rounded-3xl blur-2xl z-0" />
      {/* Card */}
      <div className="relative z-10 text-center p-10 bg-white/90 shadow-2xl border border-primary/10 rounded-2xl max-w-lg mx-auto backdrop-blur-md transition-transform hover:scale-105 duration-300 animate-fade-in">
        <SentimentDissatisfiedIcon className="text-primary mb-4 animate-bounce" style={{ fontSize: 100 }} />
        <h1 className="text-6xl font-extrabold text-primary mb-4 drop-shadow-lg">404</h1>
        <p className="text-lg text-body mb-4 font-medium">Oh no! The page you're looking for doesn't exist.</p>
        <p className="text-base text-grey mb-8">It seems you've wandered off somewhere... Let's get you back on track.</p>
        <ThemeButton
          type="button"
          label="Back To Dashboard"
          onClick={handleGoHome}
          className="w-full max-w-xs mx-auto mt-4 text-base font-bold py-3 rounded-full shadow-lg hover:scale-105 transition-all duration-200"
          primaryColor="bg-primary"
          secondaryColor="bg-accentSecondary"
          textColor="#fff"
          hoverTextColor="#160033"
        />
      </div>
      {/* Bottom text */}
      <div className="relative z-10 mt-10 text-body">
        <p className="text-lg text-dark">
          Feeling lost? Head back to <span className="text-accent font-bold cursor-pointer hover:underline" onClick={handleGoHome}>Dashboard</span> or contact support if the issue persists.
        </p>
      </div>
    </div>
  );
};

export default NotFoundPage;
